<app-kpi-widget
  [title]="title"
  [icon]="'ph-duotone ph-x-square'"
  [isLoading]="isLoading"
  [totalValue]="value"
  [percentageDifference]="percentageDifference"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [isUptrendPositive]="false"
  [valueFormatter]="formatValue.bind(this)"
  [isImageIcon]="false"
  [dropdownEnabled]="false"
  [hasFooter]="false"
  [hasValueOnly]="true"
  [hasDifference]="false"
></app-kpi-widget>